import AppApi from "api/App/AppApi";
import AppConstants from "global/constants/AppConstants";
import { Result } from "global/constants/AppType";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

const useDetailModel = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [resultObject, setResultObject] = useState<Result | null>(null);

  const [id, setId] = useState<string | null>(null);
  const [type, setType] = useState<string | null>(null);
  const [detail, setDetail] = useState<any>();

  const intervalRef = useRef<NodeJS.Timer | null>(null);

  // Hàm lấy dữ liệu chung
  const getListHistory = async (id: string, type: string) => {
    try {
      setLoading(true);

      const apiMap: Record<string, (id: string) => Promise<any>> = {
        orderDkttb: AppApi.getDkttbDetail,
        user: AppApi.getUserDetail,
        mer: AppApi.getMerDetail,
        transaction: AppApi.transactionDetail,
      };

      const apiFunc = apiMap[type];
      if (!apiFunc) return;

      const response = await apiFunc(id);

      if (response?.data) {
        setDetail(response.data);
      }
    } catch (error) {
      console.error(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const onDetailCard = async (id: string) => {
    try {
      const response = await AppApi.dataDetail(id);

      if (response?.code === 0) {
        setDetail(response.data);
      } else {
        setResultObject({
          type: "error",
          message: response?.message || "Lỗi khi xác nhận nạp tiền",
        });
      }
    } catch (error) {
      console.error(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    }
  };

  useEffect(() => {
    if (!id || !type) return;

    const fetchData = async () => {
      if (type === "transaction") {
        await onDetailCard(id);
      } else {
        await getListHistory(id, type);
      }
    };

    fetchData();
  }, [id, type]);

  useEffect(() => {
    if (type !== "transaction" || !id) return;
    if (!detail) return;

    if (detail.status === "INIT" || detail.status === "IN_PROGRESS") {
      if (intervalRef.current) clearInterval(intervalRef.current);

      intervalRef.current = setInterval(() => {
        onDetailCard(id);
      }, 5000);

      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
      };
    }
  }, [id, type, detail?.status]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const idParam = searchParams.get("id");
    const typeParam = searchParams.get("type");

    if (idParam) {
      setId(idParam);
      setType(typeParam);
    }
  }, [location.search]);

  const reload = async () => {
    if (id && type) {
      if (type === "transaction") {
        await onDetailCard(id);
      } else {
        await getListHistory(id, type);
      }
    }
  };

  return {
    loading,
    resultObject,
    type,
    detail,
    getListHistory,
    setResultObject,
    reload,
  };
};

export default useDetailModel;
